import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import MuiSwitch from '@material-ui/core/Switch';
import React from 'react';

import useStyles from './styles';

export type SwitchProps = {
  checked: boolean;
  className?: string;
  disabled?: boolean;
  label?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

/**
 * @deprecated
 * @example
 *
 *  Use `@material-ui/core/Switch` and `@material-ui/core/FormControlLabel` instead.
 *
 *  ```
 *  <FormControlLabel
 *    control={
 *      <Switch checked={checked} onChange={handleChange} name="ralph" />
 *    }
 *    label="Ralph DiMaggio"
 *  />
 *  ```
 */

export const Switch: React.FC<SwitchProps> = ({ label, checked, onChange, className, disabled = false }) => {
  const classes = useStyles();

  return label ? (
    <FormGroup className={className}>
      <FormControlLabel
        classes={{
          label: classes.label,
          root: classes.labelRoot,
        }}
        control={
          <MuiSwitch
            checked={checked}
            classes={{
              checked: classes.switchChecked,
              root: classes.switchRoot,
              switchBase: classes.switchBase,
              thumb: classes.switchThumb,
              track: classes.switchTrack,
            }}
            disabled={disabled}
            onChange={onChange}
          />
        }
        label={label}
      />
    </FormGroup>
  ) : (
    <MuiSwitch
      checked={checked}
      classes={{
        checked: classes.switchChecked,
        root: classes.switchRoot,
        switchBase: classes.switchBase,
        thumb: classes.switchThumb,
        track: classes.switchTrack,
      }}
      disabled={disabled}
      onChange={onChange}
    />
  );
};

export default Switch;
